<script lang="ts">
    import AtAGlanceRow from './AtAGlanceRow.svelte';

    /**
   * A readable Svelte store of an individual Race.
   *
   *  @type {import('../types.d').RaceFeed}
   */
    export let race;

    /**
     * @type {Map<string, import('../types.d').Crosswalk>}
     */
    export let crosswalk;

        /**
     * @type {string}
     */
     export let label;

    function getAnchorTag(raceId) {
      if (raceId == 'CA-P8686-2024-03-05') {
        return 'president-dem';
      } else if (raceId == 'CA-P8688-2024-03-05') {
        return 'president-gop';
      } else if (raceId == 'CA-I82014-2024-03-05') {
        return 'statewide-section'
      } else if (raceId == 'CA-S8589-2024-03-05'){
        return 'congressional-section'
      } else if (raceId == 'CA-D82127-2024-03-05') {
        return 'county-section'
      } else if (raceId == '1266') {
        return 'city-section'
      } else if (raceId == '8500-orange' || raceId == '8503-orange'){
        return 'city-section'
      } else if (raceId == '9620-orange' || raceId == '9619-orange'){
        return 'schools-section'
      } else {
        return raceId;
      }
    }

    $: idName = getAnchorTag($race.id);

      // presidential race dropped out candidates list
    let droppedOutCandidates = [
        'polid-60051',
        'polid-62557',
        'polid-5956',
        'polid-71843',
        'polid-60420'
    ];
  
  </script>
    <p class="aag-race">{label? label: $race.name}</p>
    <p class="aag-leading" aria-hidden='{($race.office == 'I') && ($race.office == 'Cities') && ($race.race_type == 'r') && ($race.race_type == 'm')? 'true' : 'false'}'>
      {#if ($race.office !== 'I') && ($race.office !=='Cities') && ($race.race_type !== 'r') && ($race.race_type !== 'm') }
        Leading candidates
      {:else}
        {@html '<br/>'}
      {/if}


  <table class="contest__candidates aag">
    <tbody>
        {#each $race.candidates as c, idx (c.ap_id)}
          {#if idx < 2}
          <tr
          class="candidate contest__candidate-row contest__candidate-row-{c.party}"
          class:contest__candidate-row-winner={c.is_winner}>
          <AtAGlanceRow 
            candidateGivenName = {c.given_name}
            candidateFamilyName = {c.family_name}
            isIncumbent = {c.is_incumbent}
            isWinner = {c.is_winner}
            candidateParty = {c.party}
            candidateVotes = {c.votes}
            totalVotes = {$race.total_votes}
            lookup={crosswalk.get(c.ap_id)}
            raceID = {$race.id}
            isRunoff = {c.is_runoff}
            hasDroppedOut = {droppedOutCandidates.includes(c.ap_id)}
          />
          </tr>
          {/if}
        {/each}
    </tbody>
    <tfoot>
      <tr>

        <td class="contest__precincts" colspan=2 aria-hidden="{$race.eevp ? 'false' : 'true'}">
          {#if $race.eevp}
            {$race.eevp}% of expected vote in
          {:else}
            <br/>
          {/if}
        </td>
        <td class="link-to-section text-right" colspan="2"><a href="#{idName}" aria-label="Link to go to race">Go to race &raquo;</a></td>
      </tr>
    </tfoot>
  </table>
  